import React from 'react';
import { navigate } from 'gatsby-link';
import { withAppContext, AppContextType } from 'context/AppContext';
import { getTwoLetterLanguageCode } from 'helpers/getTwoLetterLanguageCode';
import { languagesListCopyMapping, AlternateLanguage } from 'types';
import { isHomePage } from 'helpers';
import { FooterArrow } from './Arrow';

const makeUrl = (lang: string, uid: string) => `/${getTwoLetterLanguageCode(lang)}/${uid}/`;
const makeAHomeUrl = (lang: string) => `/${getTwoLetterLanguageCode(lang)}/`;
const getLanguageCopy = (lang: string): string =>
    languagesListCopyMapping[getTwoLetterLanguageCode(lang)];

type SelectData = {
    value: string;
    text: any;
};

const createSelectData = (
    currentUid: string,
    alternateLanguages: AlternateLanguage[],
): SelectData[] =>
    alternateLanguages.map(alternateLanguage => {
        const value = isHomePage(currentUid)
            ? makeAHomeUrl(alternateLanguage.lang)
            : makeUrl(alternateLanguage.lang, alternateLanguage.uid);
        const text = getLanguageCopy(alternateLanguage.lang);
        return { value, text };
    });

const LanguageSelector = withAppContext(
    ({
        context: {
            pageContext: { uid: currentUid, lang },
            alternateLanguages,
        },
    }: {
        context: AppContextType;
    }) => {
        const data = createSelectData(currentUid, alternateLanguages);
        const currentLanguageCopy = getLanguageCopy(lang);
        return (
            <div className="Select">
                <select
                    className="Select-control"
                    onChange={event => navigate(event.currentTarget.value)}
                    aria-label="language selector"
                >
                    <option className="LanguageSelector-option" value={''}>
                        {currentLanguageCopy}
                    </option>
                    {data.map(({ value, text }) => (
                        <option key={value} value={value}>
                            {text}
                        </option>
                    ))}
                </select>
                <span className="Select-arrow Icon">
                    <FooterArrow />
                </span>
            </div>
        );
    },
);

export { LanguageSelector };
